import { useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import * as htmlToImage from "html-to-image";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { reduxshow } from "store/hello";
import ItemSelector from "./components/ItemSelector";
import { ContainerStyle } from "./styled";

export default (props) => {
  const { duration } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const elementRef = React.useRef(null);
  const captureRef = React.useRef(null);
  const dispatch = useDispatch();
  const show = useSelector((sto) => sto.hello.show);
  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  // const show = false;
  // const c1 = "bg-dark";
  const c1 = "";
  const c2 = "";
  const cap = async () => {
    dispatch(reduxshow(false));
    await delay(200);
    try {
      const element = captureRef.current;
      const blob = await htmlToImage.toBlob(element, {
        pixelRatio: 1,
        style: { width: element.offsetWidth + "px" },
      });
      if (blob) {
        await navigator.clipboard.write([
          new ClipboardItem({
            "image/png": blob,
          }),
        ]);
      }
      dispatch(reduxshow(true));
    } catch (error) {
      dispatch(reduxshow(true));
    }
  };
  return (
    <motion.div
      initial={{ x: -10, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 10, opacity: 0 }}
      transition={{ duration: duration }}
    >
      <ContainerStyle sx={{ pt: isMobile ? 2 : 5, textAlign: "center" }}>
        <div
          className={`container-fluid justify-content-center ${
            isMobile ? "w-100" : "w-50 mx-auto"
          }`}
          ref={elementRef}
        >
          {show && (
            <div className="d-flex justify-content-end">
              <button className="btn btn-primary" onClick={cap}>
                copy
              </button>
            </div>
          )}
          <div ref={captureRef}>
          {[0, 1, 2].map((rowIndex) => (
            <div className="row justify-content-center" key={rowIndex}>
              {[0, 1, 2].map((colIndex) => {
                const index = rowIndex * 3 + colIndex;
                const type = index + 1;
                const isFirst = index === 0;
                const bgClass = index % 2 === 0 ? c1 : c2;

                return (
                  <div
                    key={type}
                    className={`col-md-4 ${
                      show ? "col-lg-2" : ""
                    } col-4 ps-0 pe-0 align-content-center ${bgClass}`}
                  >
                    <div className="ratio ratio-1x1">
                      {isFirst ? (
                        <ItemSelector d />
                      ) : (
                        <ItemSelector type={type} />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
          </div>
        </div>
      </ContainerStyle>
    </motion.div>
  );
};
